// extracted by css-extract-rspack-plugin
export default {"infoContainer":"infoContainer-fQ0txM","info":"info-p6lL5v"};